



































































































































































































































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

// Types and classes
import { Module } from '@/models/configurator/module';
import { Question, QuestionType } from '@/models/configurator/question';
import ALPage from '@/components/core/Page/ALPage.vue';
import QuestionTagsManagerFormDialog from '@/components/configurator/question/QuestionTagsManagerFormDialog.vue';

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    questionTagsFormDialog: InstanceType<typeof QuestionTagsManagerFormDialog>;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  name: 'ModuleDetailPage',

  components: { ALPage, QuestionTagsManagerFormDialog },

  props: ['moduleId'],

  data: () => ({
    loading: false,

    questionChoiceTypes: [
      { text: 'Text', value: QuestionType.Value },
      { text: 'Multiple Choice', value: QuestionType.MultipleChoice },
      { text: 'Numeric Choice', value: QuestionType.NumericChoice }
    ],

    QuestionType,

    newQuestion: (null as unknown) as Question
  }),

  computed: {
    getModuleById: get<(id: number) => Module>(
      'configuratorModule/getModuleById'
    ),

    questions: get<Question[]>('configuratorQuestion/questions'),

    sortedQuestions: get<Question[]>('configuratorQuestion/sortedQuestions'),

    module(): Module {
      return this.getModuleById(Number(this.moduleId));
    }
  },

  methods: {
    ...mapActions('configuratorQuestion', ['fetchQuestions', 'deleteQuestion']),

    ...mapActions('configuratorModule', [
      'createModule',
      'fetchModule',
      'fetchModules',
      'updateModule'
    ]),

    async destroyQuestion(question: Question) {
      const confirm = (this as any).$refs.confirm;

      if (
        await confirm.open(
          'Delete Question',
          {},
          `<span style="line-height: 19px;">Are you sure you want to delete <strong class="text--primary" style="word-break: normal">${question.text}</strong>? <br /> This action cannot be undone.</span>`
        )
      ) {
        await this.deleteQuestion(question).then(() =>
          this.fetchQuestionsList()
        );
      }
      return;
    },

    addProxyQuestion() {
      const configuratorQuestionFormDialog = (this as any).$refs
        .configuratorQuestionFormDialog;
      configuratorQuestionFormDialog.open(undefined, this.moduleId, true);
    },

    editProxyQuestion(question: Question) {
      const configuratorQuestionFormDialog = (this as any).$refs
        .configuratorQuestionFormDialog;
      configuratorQuestionFormDialog.open(question, this.moduleId, false);
    },

    openQuestionTagsDialog(question: Question) {
      this.$refs.questionTagsFormDialog.open(question);
    },

    showQuestionWarning(question: Question): boolean {
      return Boolean(question.errors && question.errors.length);
    },

    fetchQuestionsList() {
      this.fetchQuestions({ module: Number(this.moduleId) });
    }
  },

  async mounted() {
    this.loading = true;

    if (!this.module) {
      await this.fetchModule(this.moduleId);
    }

    this.fetchQuestions({ module: Number(this.moduleId) }).finally(
      () => (this.loading = false)
    );
  }
});
